import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular/standalone';
import { ApiConfiguration } from 'src/app/api/api-configuration';
import { AuthenticationApiService, VersionApiService } from 'src/app/api/services';
import { AuthService } from 'src/app/core/auth/auth.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { environment } from 'src/environments/environment';
import { StorageEnums } from 'src/shared/models/enums';
import { CustomSpinnerService } from './custom-spinner.service';
import { ApiConfiguration as ApiConfigurationMsp } from 'src/app/msp-api/api-configuration';
import { HelperService } from './helper.service';
import { MyLogger } from './logging.service';


interface StageUsers {
	stageUsers: [
		{ email: string }
	]
}

@Injectable({
	providedIn: 'root'
})
export class InitializedService extends MyLogger {

	constructor(private spinner: CustomSpinnerService,
				private router: Router,
				private helpService: HelperService,
				private AuthenticationApiService: AuthenticationApiService,
				private platform: Platform,
				public authService: AuthService,
				private versionService: VersionApiService,
				private apiConfiguration: ApiConfiguration,
				private apiConfigurationMsp: ApiConfigurationMsp,
				private http: HttpClient,
				private storage: StorageService
				) {
		super('InitializedService');
	}


	async initData() {
		return await this.platform.ready().then(() => {
			this.storage.setItem(StorageEnums.ApiUrl, (!document.location.origin.includes('localhost') ? document.location.origin: environment.api));
			if(!document.location.origin.includes('localhost')) this.apiConfiguration.rootUrl = document.location.origin;
			return new Promise<void>(async (resolve) => {
				const auth = await this.storage.getItem(StorageEnums.AUTH_TOKEN);
				// if (networkStatus !== 'none') {
					this.http.get('https://live.v-locker.ch/.app/init-config.json')
						// 	of({
						// 		stageUsers: [
						// 			{ email: 'live_test@v-locker.ch' }
						// 		]
						// 	})
						.subscribe(async ({ stageUsers }: StageUsers) => {
								this.log('stageUsers', stageUsers);
								await this.storage.setItem(StorageEnums.EmailsForFilter, stageUsers);
								let userEmail = await this.storage.getItem(StorageEnums.USER_EMAIL);
								if (auth) {
									let found = stageUsers.find(user => user.email === userEmail);
									if (found && document.location.origin.includes('live')) {
										this.apiConfiguration.rootUrl = environment.testApi;
										this.apiConfigurationMsp.rootUrl = environment.testApi;
										await this.storage.setItem(StorageEnums.ApiUrl, environment.testApi);
										await this.storage.setItem(StorageEnums.IsStage, true);
										console.log('changed API url', this.apiConfiguration.rootUrl);
									} else {
										await this.storage.removeItem(StorageEnums.IsStage);
										await this.storage.setItem(StorageEnums.ApiUrl, (!document.location.origin.includes('localhost') ? document.location.origin: environment.api));
									}
									this.authService.updateAuth(true);
									this.spinner.show().then(() => {
										this.AuthenticationApiService.refreshToken().subscribe(async (v) => {
											await this.storage.setItem(StorageEnums.REFRESH_TOKEN, v.refreshToken);
											await this.storage.setItem(StorageEnums.AUTH_TOKEN, v.accessToken);
											this.authService.checkVerification(() => {
												resolve();
												this.spinner.hide();
											}, () => {
												resolve();
												this.spinner.hide();
											});
										}, error => {
											resolve();
											this.spinner.hide();
										});
									});
								} else {
									resolve();
								}
							},
							error => {
								resolve();
							})
				// }
			});
		})
	}

	checkVersion() {
		return this.platform.ready().then(() => {
			return new Promise<void>((resolve) => {
				// let user = this.storageService.getItem(StorageEnums.AUTH_TOKEN);
				// if (user) {
				this.doCheckVersion(resolve)
			});
		})
	}

	doCheckVersion(resolve) {
		this.versionService.getVersion()
			.subscribe(v => {
				try {
					let version;
					let check = async () => {
						await this.helpService.isAppVersionInvalid(v.minimumVersion, version);
						resolve();
					}

					version = environment.testAppVersion;
					check();
					// resolve();
				} catch (e) {
					this.router.navigate(['/app-version']);
				}
			}, error => {
				resolve();
				// this.router.navigate(['/app-version']);
				this.router.navigate(['/']);
			});
	}
}
